import { uuid4 } from './misc.js';

/**
 * Returns a new minimal propagation context
 */
function generatePropagationContext() {
  return {
    traceId: uuid4(),
    spanId: uuid4().substring(16),
  };
}

export { generatePropagationContext };
//# sourceMappingURL=propagationContext.js.map
